module.exports = __webpack_public_path__ + "img/pegasus.fb90bd8a.png";